import { render, staticRenderFns } from "./ModelsCatalog.vue?vue&type=template&id=64508932&scoped=true&"
import script from "./ModelsCatalog.vue?vue&type=script&lang=js&"
export * from "./ModelsCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ModelsCatalog.vue?vue&type=style&index=0&id=64508932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64508932",
  null
  
)

export default component.exports